import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CloseIcon from "@mui/icons-material/Close";
import Day1 from "../../assets/Images_WorkshopSchedule/Day1.png";
import Day2 from "../../assets/Images_WorkshopSchedule/Day2.png";
import Day3 from "../../assets/Images_WorkshopSchedule/Day3.png";
import Day4 from "../../assets/Images_WorkshopSchedule/Day4.jpg";
import Day5 from "../../assets/Images_WorkshopSchedule/Day5.png";
import Day6 from "../../assets/Images_WorkshopSchedule/Day6.png";
import Day9 from "../../assets/Images_WorkshopSchedule/Day9.png";
import Day10 from "../../assets/Images_WorkshopSchedule/Day10.png";
import Day8 from "../../assets/Images_WorkshopSchedule/3d.png";
import Day7 from "../../assets/Images_WorkshopSchedule/Day7.png";

const WorkshopSchedule = () => {
  useEffect(() => {
    document.title = "Workshop Schedule - MS Digital Hub";
  }, []);
  const scheduleData = [
    {
      date: "2025-06-16",
      title: "Orientation",
      description:
        "Introductions, tour of campus, schedule outline, and team activities",
      icon: (
        <IconButton
          sx={{
            borderRadius: 0,
            padding: 0,
            background: "transparent",
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <Box
            component="img"
            src={Day1}
            alt="Custom Icon"
            sx={{
              width: 80,
              height: 80,
              transition: "transform 0.3s ease-in-out",
              "&:hover": {
                transform: "scale(1.1)",
              },
            }}
          />
        </IconButton>
      ),
    },
    {
      date: "2025-06-17",
      title: "Digital Humanities + Digitization",
      description:
        "Introducing digitization techniques through USM DigiLab to think about how to build a variety of projects, including some we will provide as practice samples",
      icon: (
        <IconButton
          sx={{
            borderRadius: 0,
            padding: 0,
            background: "transparent",
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <Box
            component="img"
            src={Day2}
            alt="Custom Icon"
            sx={{
              width: 80,
              height: 80,
              transition: "transform 0.3s ease-in-out",
              backgroundColor: "transparent",
              "&:hover": {
                transform: "scale(1.1)",
              },
            }}
          />
        </IconButton>
      ),
    },
    {
      date: "2025-06-18",
      title: "Data Hygiene",
      description:
        "Organizing data effectively using website builders (Wix, Squarespace, Wordpress, etc.) and appropriate planning techniques",
      icon: (
        <IconButton
          sx={{
            borderRadius: 0,
            padding: 0,
            background: "transparent",
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <Box
            component="img"
            src={Day3}
            alt="Custom Icon"
            sx={{
              width: 80,
              height: 80,
              transition: "transform 0.3s ease-in-out",
              "&:hover": {
                transform: "scale(1.1)",
              },
            }}
          />
        </IconButton>
      ),
    },
    {
      date: "2025-06-19",
      title: "Markup + Archiving",
      description:
        "Presenting information through metadata using Digital Humanities tools (TEI and Omeka)",
      icon: (
        <IconButton
          sx={{
            borderRadius: 0,
            padding: 0,
            background: "transparent",
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <Box
            component="img"
            src={Day4}
            alt="Custom Icon"
            sx={{
              width: 80,
              height: 80,
              transition: "transform 0.3s ease-in-out",
              "&:hover": {
                transform: "scale(1.1)",
              },
            }}
          />
        </IconButton>
      ),
    },
    {
      date: "2025-06-20",
      title: "GIS Mapping",
      description:
        "Introducing Geographical Information System software and exploring the ways it can be used to display spatial information",
      icon: (
        <IconButton
          sx={{
            borderRadius: 0,
            padding: 0,
            background: "transparent",
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <Box
            component="img"
            src={Day5}
            alt="Custom Icon"
            sx={{
              width: 80,
              height: 80,
              transition: "transform 0.3s ease-in-out",
              "&:hover": {
                transform: "scale(1.1)",
              },
            }}
          />
        </IconButton>
      ),
    },
    {
      date: "2025-06-23",
      title: "Ethical Data Visualizations",
      description:
        "Analyzing examples of how data is presented and learning best practices for honest portrayal of information",
      icon: (
        <IconButton
          sx={{
            borderRadius: 0,
            padding: 0,
            background: "transparent",
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <Box
            component="img"
            src={Day6}
            alt="Custom Icon"
            sx={{
              width: 80,
              height: 80,
              transition: "transform 0.3s ease-in-out",
              "&:hover": {
                transform: "scale(1.1)",
              },
            }}
          />
        </IconButton>
      ),
    },
    {
      date: "2025-06-24",
      title: "AI + A/V",
      description:
        "Learning how Artificial Intelligence can automate parts of DH projects, and also learning innovative video techniques to make Audio/Visual material more accessible to an audience",
      icon: (
        <IconButton
          sx={{
            borderRadius: 0,
            padding: 0,
            background: "transparent",
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <Box
            component="img"
            src={Day7}
            alt="Custom Icon"
            sx={{
              width: 80,
              height: 80,
              transition: "transform 0.3s ease-in-out",
              "&:hover": {
                transform: "scale(1.1)",
              },
            }}
          />
        </IconButton>
      ),
    },
    {
      date: "2025-06-25",
      title: "Multimodal Tools",
      description:
        "Broadening horizons of tools available by practicing with multimodal tools (LiDar scanning, drone filming, 3D printing, etc.)",
      icon: (
        <IconButton
          sx={{
            borderRadius: 0,
            padding: 0,
            background: "transparent",
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <Box
            component="img"
            src={Day8}
            alt="Custom Icon"
            sx={{
              width: 80,
              height: 80,
              transition: "transform 0.3s ease-in-out",
              "&:hover": {
                transform: "scale(1.1)",
              },
            }}
          />
        </IconButton>
      ),
    },
    {
      date: "2025-06-26",
      title: "Grant Writing + Project Planning",
      description:
        "Encountering information required when writing a grant proposal and using those prerequisites to draft a mock project plan",
      icon: (
        <IconButton
          sx={{
            borderRadius: 0,
            padding: 0,
            background: "transparent",
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <Box
            component="img"
            src={Day9}
            alt="Custom Icon"
            sx={{
              width: 80,
              height: 80,
              transition: "transform 0.3s ease-in-out",
              "&:hover": {
                transform: "scale(1.1)",
              },
            }}
          />
        </IconButton>
      ),
    },
    {
      date: "2025-06-27",
      title: "Building Conversation",
      description:
        "Discussing individual achievements throughout workshop, reminding participants of resources available through the CDH Hub, and brainstorming future collaborations",
      icon: (
        <IconButton
          sx={{
            borderRadius: 0,
            padding: 0,
            background: "transparent",
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <Box
            component="img"
            src={Day10}
            alt="Custom Icon"
            sx={{
              width: 80,
              height: 80,
              transition: "transform 0.3s ease-in-out",
              "&:hover": {
                transform: "scale(1.1)",
              },
            }}
          />
        </IconButton>
      ),
    },
  ];

  const [selectedEvent, setSelectedEvent] = useState(null);

  const handleEventClick = (event) => {
    setSelectedEvent(event);
  };

  const handleClosePopup = () => {
    setSelectedEvent(null);
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: 3,
        padding: 4,
        bgcolor: "",
        minHeight: "100vh",
      }}
    >
      {/* Left Side: Google Calendar Embed
      <Box sx={{ width: "350px", bgcolor: "#fff", borderRadius: 2, boxShadow: 2, p: 2 }}>
        <Typography variant="h6" textAlign="center">Workshop Calendar</Typography>
        <iframe 
          src="https://calendar.google.com/calendar/embed?src=4a88538adf7e8dce23c338c4358533f6c77db8b1d4974619f0d55b0d9fb4e5ae%40group.calendar.google.com&ctz=America%2FNew_York" 
          style={{ width: "100%", height: "400px", border: "none" }}
          title="Google Calendar"
        />
      </Box> */}

      <Box sx={{ flexGrow: 1 }}>
        <Typography
          variant="h4"
          mb={2}
          sx={{ textAlign: "center", marginBottom: "30px" }}
        >
          Workshop Schedule
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "repeat(1, 1fr)",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
            },
            gap: 2,
          }}
        >
          {scheduleData.map((event, index) => (
            <Tooltip title="Click to know more">
              <Box
                key={index}
                sx={{
                  border: "1px solid #ddd",
                  borderRadius: 2,
                  p: 2,
                  cursor: "pointer",
                  transition: "transform 0.3s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.05)",
                    bgcolor: "#fffbe7",
                  },
                }}
                onClick={() => handleEventClick(event)}
              >
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ textAlign: "center" }}
                >
                  {(() => {
                    const [year, month, day] = event.date
                      .split("-")
                      .map(Number);
                    const eventDate = new Date(Date.UTC(year, month - 1, day));

                    return eventDate.toLocaleDateString("en-US", {
                      weekday: "long",
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                      timeZone: "UTC",
                    });
                  })()}
                </Typography>
                <Box
                  mt={1}
                  display="flex"
                  alignItems="center"
                  gap={1}
                  sx={{ flexDirection: "column" }}
                >
                  <Typography variant="h6">Day{index + 1}</Typography>
                  <Typography sx={{ fontSize: 24 }}>{event.icon}</Typography>
                  <Typography variant="h6">{event.title}</Typography>
                </Box>
              </Box>
            </Tooltip>
          ))}
        </Box>
      </Box>

      <Dialog
        open={Boolean(selectedEvent)}
        onClose={handleClosePopup}
        maxWidth="sm"
        fullWidth
        sx={{ textAlign: "center" }}
      >
        {selectedEvent && (
          <>
            <DialogTitle>
              <Typography variant="subtitle1" color="textSecondary">
                {(() => {
                  const [year, month, day] = selectedEvent.date
                    .split("-")
                    .map(Number);
                  const eventDate = new Date(Date.UTC(year, month - 1, day));

                  return eventDate.toLocaleDateString("en-US", {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    timeZone: "UTC",
                  });
                })()}{" "}
              </Typography>
              <IconButton
                onClick={handleClosePopup}
                sx={{ position: "absolute", right: 10, top: 10 }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              {selectedEvent.title}
              <Typography sx={{ fontSize: 24 }}>
                {selectedEvent.icon}
              </Typography>
              {/*  <Box mt={2} textAlign="center">
                <img src="https://via.placeholder.com/300" alt="Event" width="100%" style={{ borderRadius: 8 }} />
              </Box>*/}
              <Typography mt={2}>{selectedEvent.description}</Typography>
            </DialogContent>
          </>
        )}
      </Dialog>
    </Box>
  );
};

export default WorkshopSchedule;
